import { useSelector } from "react-redux"

import ExportDropdown from "../../../../Components/Export"

// §BLOCK 1.2 — the Header's right side. Реєструється в TitleSectionContext з ReceiptPage/index.js.
// The "Learn more about Digital Receipt" button and its FAQ modal are hidden until the FAQ is
// rewritten (CHA1-4622); they come back from this file's history together with the FaqStub modal.
const LearnMoreAction = ({ isMobile, isAdminPage, isActive, isDemo, canExport, onExport }) => {
  const { exportFetching } = useSelector((s) => s.receipt)

  if (!isMobile || !isActive || !canExport) return null

  return (
    <ExportDropdown
      loading={exportFetching}
      onExport={onExport}
      isAdmin={isAdminPage}
      disabled={isDemo}
      iconButton
      inHeader
    />
  )
}

export default LearnMoreAction
